import React, { useState } from "react";
import uploadSign from "../../assests/images/cloud.png";

import crossImg from "../../assests/images/Frame.png";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import Spinner from "../../shared/spinner/Spinner";
import { Toast } from "../../shared/toaster/Toaster";
import { handleError } from "../../shared/HttpReq";

function PassengerDetails() {
  const [isLoading, setLoading] = useState(false);
  const [toaster, SetToaster] = useState({
    show: false,
    type: "", // type should be "danger" or "success"
    content: "",
  });

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();

  const [picture, setPicture] = useState({
    file: "",
    url: "",
  });
  const [passengerDetails, setPassengerDetails] = useState({
    height: "",
    weight: "",
  });

  const deleteImage = () => {
    setPicture({
      file: "",
      url: "",
    });
  };
  const handleChange = (e) => {
    setPassengerDetails((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const uploadImg = async (e) => {
    const file = e.target.files[0];
    setPicture({
      file: file,
      url: URL.createObjectURL(file),
    });

    const formData = new FormData();
    formData.append("file", file);
    const res = fetch(`${process.env.REACT_APP_BASE_URL}/media`, {
      method: "POST",
      body: formData,
    });
    res.then((res) => {
      try {
        return res.json().then((responseJSON) => {
          setPicture((prev) => {
            return { ...prev, name: responseJSON[0] };
          });
          if (res.status === 200) {
            setLoading(false);
            SetToaster(
              {
                show: true,
                type: "success",
                content: "Image Upload Successfully",
              },
              2000
            );
          } else {
            setLoading(false);
            SetToaster({
              show: true,
              type: "danger",
              content: res.message,
            });
          }
        });
      } catch (e) {
        console.error(e);
      }
    });

    if (res.status === 200) {
      setLoading(false);
      SetToaster(
        {
          show: true,
          type: "success",
          content: res.message,
        },
        2000
      );
    } else {
      setLoading(false);
      SetToaster({
        show: true,
        type: "danger",
        content: res.message,
      });
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await handleError(
      await fetch(`${process.env.REACT_APP_BASE_URL}/booking/user-info`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        isSecure: true,
        body: JSON.stringify({
          token: query.get("token"),
          height: passengerDetails.height,
          weight: passengerDetails.weight,
          idProof: picture.name,
        }),
      })
    );
    if (res.status === 200) {
      setLoading(false);
      SetToaster(
        {
          show: true,
          type: "success",
          content: res.message,
        },2000
      );
      window.open("https://pelagotrips.com/", "_self");
    } else {
      setLoading(false);
      SetToaster({
        show: true,
        type: "danger",
        content: res.message,
      });
    }
    window.open("https://pelagotrips.com/", "_self");
  };

  return (
    <>
      {isLoading ? <Spinner /> : null}
      <Toast
        show={toaster.show}
        type={toaster.type}
        content={toaster.content}
        onClose={() =>
          SetToaster({
            show: false,
            type: "",
            content: "",
          })
        }
      />

      <div className="pt-0">
        <div className="container">
          <div className="passenger_details">
            <h4 className="passenger_details_inner text-center mb-4">
              You need to enter some details here
            </h4>
            <form onSubmit={submitHandler}>
              <div className="row">
                {query.get("height") === "true" ? (
                  <div className="col-lg-12">
                    <div className="input_field">
                      <label htmlFor="#">Height</label>
                      <div className="position-relative mr-3">
                        <input
                          type="number"
                          className="input-txt"
                          name="height"
                          min="0"
                          onChange={(e) => handleChange(e)}
                        />
                        <span className="ft">cm</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {query.get("weight") === "true" ? (
                  <div className="col-lg-12">
                    <div className="input_field">
                      <label htmlFor="#">Weight</label>
                      <div className="position-relative">
                        <input
                          type="number"
                          className="input-txt"
                          min="0"
                          name="weight"
                          onChange={(e) => handleChange(e)}
                        />
                        <span className="ft">Pounds</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="col-lg-12">
                  <h4 className="passenger_details_inner mt-5 mb-4">
                    Attach your ID Proof
                  </h4>
                  <div
                    className={`drag_drop_area ${
                      picture.url !== "" ? "differ_padding" : ""
                    }`}
                  >
                    <input
                      type="file"
                      className="drag_drop_area_file"
                      accept="image/*"
                      onChange={uploadImg}
                    />
                    {picture.url !== "" ? (
                      <>
                        <img
                          src={picture.url ? picture.url : ""}
                          alt=""
                          className="logoFixed"
                        />
                        <img
                          src={crossImg}
                          alt=""
                          className="crosImgonimg"
                          onClick={() => deleteImage()}
                        />
                      </>
                    ) : (
                      <div className="drag_drop_sign">
                        <img src={uploadSign} alt="" />
                        <p className="drag_drop_sign_para">
                          Drag and drop your file here
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="text-center">
                <button className="blue-bg w-70" type="submit">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default PassengerDetails;
